<template>
  <el-dialog custom-class="dialog-modal-permission" :model-value="flagVisible" width="770px" :before-close="handleClose">
    <div class="modal-permission">
      <div class="modal-p-content text-that-needs-wrapping">
        <div class="modal-p-title">
          <span>Welcome the competition.</span>
        </div>
        <div class="modal-p-desc">
          <p>When your product stands up to or surpasses the competition, let it shine! You define the race. Let your visitors hear, see, and compare for themselves.</p>
          <p>If adding other brands’ products is not part of your subscription, please contact <a href="mailto:sales@audiotestkitchen.com">sales@audiotestkitchen.com</a> to upgrade.</p>
        </div>
      </div>
      <div class="modal-p-img">
        <img src="@/assets/images/permissions/other_products.png" alt="" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal'],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
